import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AuthNavigation = () => {
  const location = useLocation();
  
  const authPages = [
    {
      path: '/page/login',
      label: 'Sign In',
      icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
        </svg>
      )
    },
    {
      path: '/page/register',
      label: 'Register',
      icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
        </svg>
      )
    },
    {
      path: '/page/reset-password',
      label: 'Reset',
      icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      )
    }
  ];

  return (
    <div className="auth-nav-links">
      {authPages.map((page) => (
        <Link
          key={page.path}
          to={page.path}
          className={`auth-nav-link ${location.pathname === page.path ? 'active' : ''}`}
        >
          {page.icon}
          <span>{page.label}</span>
        </Link>
      ))}
    </div>
  );
};

export default AuthNavigation;
